import React from 'react'
import {HiOutlineArrowNarrowLeft,HiOutlineArrowNarrowRight} from 'react-icons/hi'
import { FormattedMessage } from 'react-intl'


const Pagination = ({setCurrentPage , currentPage , perPage,offset,total_pages,count }) => {


    const handleNext=()=>{
        setCurrentPage(currentPage+1)
    }

    const handlePrevious=()=>{
        setCurrentPage(currentPage-1)
    }
    return (
        <div className="flex flex-col justify-center items-center">
            <span className="text-sm text-gray-700 dark:text-gray-400 space-x-1">
            <FormattedMessage id="Showing" defaultMessage={"Showing"} /> <span className="font-semibold text-gray-900 ">{currentPage===1 ? count ==0 ? 0 : 1: offset+(perPage*(currentPage-1))}</span> <FormattedMessage id="to" defaultMessage={"to"} /> <span className="font-semibold text-gray-900 ">{currentPage ===1? count>perPage? perPage:count: currentPage * perPage + offset > count ? count : currentPage * perPage + offset }</span> <FormattedMessage id="of" defaultMessage={"of"} /> <span className="font-semibold text-gray-900 ">{count}</span> <FormattedMessage id="entries" defaultMessage={"Entries"} />
            </span>
            <div className="inline-flex mt-4  ">
                <button type='button' className=" space-x-2 inline-flex items-center px-4 py-2 text-sm font-medium text-white rounded-l-[10px] bg-primary disabled:bg-gray-300 "
                disabled={currentPage===1}
                onClick={()=>handlePrevious()}
                >
                    <HiOutlineArrowNarrowLeft className=' text-xl text-white' />
                    <span><FormattedMessage id="perv" defaultMessage={"Prev"} /></span>
                </button>
                <button type='button' className=" space-x-2 inline-flex items-center px-4 py-2 text-sm font-medium text-white  border-0 border-l border-white rounded-r-[10px] bg-primary disabled:bg-gray-300 "
                onClick={()=>handleNext()}
                disabled={
                    (currentPage===total_pages || total_pages===1 ||total_pages===0) ? true :false 
                }
                >
                    <span><FormattedMessage id="next" defaultMessage={"Next"} /></span>
                    <HiOutlineArrowNarrowRight className=' text-xl text-white' />
                </button>
            </div>
        </div>
    )
}

export default Pagination